import { render, staticRenderFns } from "./JiaotongFangshi.vue?vue&type=template&id=5cf0ca31&scoped=true&"
import script from "./JiaotongFangshi.vue?vue&type=script&lang=js&"
export * from "./JiaotongFangshi.vue?vue&type=script&lang=js&"
import style0 from "./JiaotongFangshi.vue?vue&type=style&index=0&id=5cf0ca31&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0ca31",
  null
  
)

export default component.exports